import React, { useEffect, useState } from 'react'
import { bankApi, Bank } from '@/api/banks'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSelect: (bank: Bank) => void
}

export const BankSelectModal: React.FC<Props> = ({ isOpen, onClose, onSelect }) => {
  const [search, setSearch] = useState('')
  const [items, setItems] = useState<Bank[]>([])
  const [loading, setLoading] = useState(false)
  const [activeOnly, setActiveOnly] = useState(true)

  const fetchBanks = async () => {
    setLoading(true)
    try {
      const res = await bankApi.list({ page_size: 100, search, is_active: activeOnly })
      setItems(res.banks || [])
    } catch { setItems([]) } finally { setLoading(false) }
  }

  useEffect(() => { if (isOpen) fetchBanks() }, [isOpen])
  useEffect(() => { const t = setTimeout(fetchBanks, 300); return () => clearTimeout(t) }, [search, activeOnly])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full max-w-2xl rounded-xl shadow-xl border border-gray-200">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold">Banka Seç</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">✕</button>
        </div>
        <div className="p-4 space-y-4">
          <div className="flex items-center gap-3">
            <input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder="Banka ara (ad, IBAN)" className="w-full px-3 py-2 border rounded-md"/>
            <label className="flex items-center gap-2 text-sm text-gray-600"><input type="checkbox" checked={activeOnly} onChange={(e)=>setActiveOnly(e.target.checked)} /> Sadece aktif</label>
          </div>
          <div className="max-h-80 overflow-auto divide-y">
            {loading ? <div className="p-4 text-gray-500">Yükleniyor...</div> : items.length === 0 ? (
              <div className="p-4 text-gray-500">Kayıt yok</div>
            ) : items.map(b => (
              <div key={b.id} className="p-3 flex items-center justify-between hover:bg-gray-50">
                <div>
                  <p className="font-medium text-gray-900">{b.name}</p>
                  <p className="text-xs text-gray-500">IBAN: {b.iban}</p>
                </div>
                <button className="px-3 py-1 border rounded-md hover:bg-gray-100" onClick={()=>onSelect(b)}>Seç</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BankSelectModal 